import {
    REQUEST_INFO_LOGIN,
    RECEIVE_INFO_LOGIN,
    UPDATE_INFO_LOGIN,
    ERROR_INFO_LOGIN
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_INFO_LOGIN:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_INFO_LOGIN:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                message: action.message,
            }
        case UPDATE_INFO_LOGIN:
            if(action.updateType == "apps"){
                const data = {...state.data}
                data.apps[action.index].pinned = action.payload

                return {
                    ...state,
                    data,
                }
            }else if(action.updateType == "theme"){
                const data = {...state.data}
                data.theme = action.payload

                return {
                    ...state,
                    data,
                }
            }
            return state
        case ERROR_INFO_LOGIN:
            return {
                ...state,
                isFetching: false,
                errors: action.errors
            }
        default:
            return state
    }
}